import React from "react";
import "animate.css/animate.min.css";
import { AnimationOnScroll } from "react-animation-on-scroll";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faLinkedin } from "@fortawesome/free-brands-svg-icons";
import { faEnvelope } from "@fortawesome/free-solid-svg-icons";

const TeamBoardMembers = () => {
  const execBoard = [
    {
      firstName: "Gui",
      lastName: "Lima",
      title: "Chief Executive Officer",
      description:
        "Gui is a junior in the SFS studying Science, Technology and International Affairs. Outside of Hoyalytics, he is an incoming intern at McKinsey & Company, as well as a Section Editor at Georgetown's Journal of International Affairs. In his free time, he enjoys watching movies, drinking coffee, and traveling.",
      email: "gsl39@georgetown.edu",
      linkedin: "https://www.linkedin.com/in/guilherme-silveira-lima/",
      headshotScale: 1.5,
      headshotY: "-5%",
    },
    {
      firstName: "Samantha",
      lastName: "Choung",
      title: "Chief Operating Officer",
      description:
        "Samantha is a senior in the College majoring in Mathematics and Economics and minoring in Chinese. Outside of academics, she enjoys listening to music, baking, and traveling. After graduation, Samantha plans on pursuing a career in wealth management.",
      email: "sc433@georgetown.edu",
      linkedin: "https://www.linkedin.com/in/samantha-choung-467015237/",
      headshotScale: 1.6,
      headshotX: "3%",
    },
    {
      firstName: "Sam",
      lastName: "Baryessa",
      title: "Chief Analytics Officer",
      description:
        "Sam is a senior in the College studying Chinese and Computer Science. He previously interned for the Institute for Critical Infrastructure and Technology. Outside of work and academics, he enjoys cooking, hiking, playing piano, watching international films, and reading.",
      email: "smb450@georgetown.edu",
      linkedin: "N/A",
      headshotScale: 1.5,
      headshotY: "13%",
    },
    {
      firstName: "Jessica",
      lastName: "Cao",
      title: "Chief Consulting Officer",
      description: "Jessica is a junior in the SFS studying Science, Technology, and International Affairs with a Computer Science minor. She has worked at the Massive Data Institute, Toast, Inc., the House of Representatives, and more. She also enjoys vlogging, acting, and reviewing restaurants on Beli.",
      email: "jkc86@georgetown.edu",
      linkedin: "https://www.linkedin.com/in/jessicakcao/",
    },
    {
      firstName: "Sarah",
      lastName: "Liang",
      title: "Chief Training Officer",
      description:
        "Sarah is a senior in the MSB studying Accounting and Operations & Analytics, with a minor in Spanish. Outside of Hoyalytics, she is a Lead Intern at Georgetown's Business Design and Optimization Group and previously interned at Protiviti. Sarah enjoys running, journaling, playing guitar, and trying new restaurants in her free time.",
        email: "sml341@georgetown.edu",
        linkedin: "https://www.linkedin.com/in/sarahmliang/",
        headshotScale: 1.85,
        headshotY: "-2%",
    },
    {
      firstName: "Helen",
      lastName: "Freedman",
      title: "Chief Marketing Officer",
      description:
        "Helen is a senior in the College studying Mathematics and English with a concentration in Creative & Public Writing. Previously, she was the Marketing & Recruitment Director for Hoya Taxa and an E-Commerce and Finance Analyst with REUSE. In her free time, Helen enjoys vintage shopping and going on long walks.",
      email: "hsf19@georgetown.edu",
      linkedin: "https://www.linkedin.com/in/helen-freedman-b14a1a245/",
    },
    {
      firstName: "Caleb",
      lastName: "Cole",
      title: "Chief HR Officer",
      description:
        "Caleb is a sophomore at Georgetown studying finance and accounting. Outside of Hoyalytics, he is involved with the Psaros Center for Financial Markets and Policy. In his free time, Caleb enjoys playing tennis, watching movies, and working out. ",
      email: "cpc88@georgetown.edu",
      linkedin: "https://www.linkedin.com/in/caleb-cole-25180730a/",
    }
  ];

    const projectManagers = [
    { firstName: "Emory", lastName: "Smith", title: "Project Manager" },
    { firstName: "Ryan", lastName: "Li", title: "Project Manager" },
    { firstName: "Jay", lastName: "Liu", title: "Project Manager", headshotScale: 1.5, headshotX: "-6%", headshotY: "-10%" },
    { firstName: "Colin", lastName: "Schlitt", title: "Project Manager", headshotScale: 1, headshotY: "0%", },
    { firstName: "Allie", lastName: "Liu", title: "Project Manager" },
    { firstName: "Max", lastName: "McCavitt", title: "Project Manager" },
    { firstName: "Lucia", lastName: "Leung", title: "Project Manager" },
    { firstName: "Zoe", lastName: "Van Zelm", title: "Project Manager" },
  ];

  const directors = [
    {
      firstName: "Priscilla",
      lastName: "Choi",
      title: "Director of Client Recruitment",
      email: "#",
      linkedin: "#",
    },
    {
      firstName: "Tommy",
      lastName: "Reichard",
      title: "Director of Client Recruitment",
      email: "#",
      linkedin: "#",
    },
    {
      firstName: "Yulian",
      lastName: "Dlaboha",
      title: "Director of Client Recruitment",
      email: "#",
      linkedin: "#",
    },
    {
      firstName: "Norah",
      lastName: "Yang",
      title: "Director of Client Recruitment",
      email: "#",
      linkedin: "#",
    },
    {
      firstName: "Saachi",
      lastName: "Rajgarhia",
      title: "Director of Alumni Relations",
      email: "#",
      linkedin: "#",
    },
    {
      firstName: "Yuri",
      lastName: "Jung",
      title: "Director of Training",
      email: "#",
      linkedin: "#",
    },
    {
      firstName: "Jake",
      lastName: "Park",
      title: "Director of Training",
      email: "#",
      linkedin: "#",
    }
  ];


  
  
  return (
    <div className="team-board-members">
      <h1 className="team-board-members-title">Hoyalytics Executive Board</h1>
      <div className="team-board-members-content">
        <div className="team-board-members-exec">
          {execBoard.slice(0, 4).map((member, index) => {
            return (
              <AnimationOnScroll
                animateIn="animate__fadeInUp"
                className="team-member-exec"
                animateOnce={true}
                key={`exec-top-${member.firstName}-${member.lastName}-${index}`}>
                <div className="team-member-headshot">
                  <img
                    src={
                      "/headshots-2026/" +
                      member.lastName +
                      ", " +
                      member.firstName +
                      ".jpg"
                    }
                    alt={member.firstName}
                    style={{
                      transform: `translate(${member.headshotX || "0%"}, ${
                        member.headshotY || "0%"
                      }) scale(${member.headshotScale || 1})`,
                    }}
                  />
                </div>
                <div className="team-member-exec-info">
                  <div className="team-member-exec-info-left">
                    <h2>{member.firstName + " " + member.lastName}</h2>
                    <h3>{member.title}</h3>
                  </div>
                  <div className="team-member-exec-info-right">
                    <a href={member.linkedin} target="_blank" rel="noreferrer">
                      <FontAwesomeIcon icon={faLinkedin} />
                    </a>
                  </div>
                </div>
                <p>{member.description}</p>
              </AnimationOnScroll>
            );
          })}
        </div>
        <div className="team-board-members-exec team-board-members-exec-bottom">
          {execBoard.slice(4).map((member, index) => {
            return (
              <AnimationOnScroll
                animateIn="animate__fadeInUp"
                className="team-member-exec"
                animateOnce={true}
                key={`exec-bottom-${member.firstName}-${member.lastName}-${index}`}>
                <div className="team-member-headshot">
                  <img
                    src={
                      "/headshots-2026/" +
                      member.lastName +
                      ", " +
                      member.firstName +
                      ".jpg"
                    }
                    alt={member.firstName}
                    style={{
                      transform: `translate(${member.headshotX || "0%"}, ${
                        member.headshotY || "0%"
                      }) scale(${member.headshotScale || 1})`,
                    }}
                  />
                </div>
                <div className="team-member-exec-info">
                  <div className="team-member-exec-info-left">
                    <h2>{member.firstName + " " + member.lastName}</h2>
                    <h3>{member.title}</h3>
                  </div>
                  <div className="team-member-exec-info-right">
                    <a href={member.linkedin} target="_blank" rel="noreferrer">
                      <FontAwesomeIcon icon={faLinkedin} />
                    </a>
                  </div>
                </div>
                <p>{member.description}</p>
              </AnimationOnScroll>
            );
          })}
        </div>
        <h1 className="team-board-members-title">Board of Directors</h1>
        <div className="team-board-members-directors">
          {directors.map((member, index) => {
            return (
              <AnimationOnScroll
                animateIn="animate__fadeInUp"
                className="team-member-director"
                animateOnce={true}
                key={member.firstName}>
                <img
                  src={
                    "/headshots-2026/" +
                    member.lastName +
                    ", " +
                    member.firstName +
                    ".jpg"
                  }
                  alt={member.firstName}
                />
                <div className="team-member-exec-info">
                  <div className="team-member-exec-info-left">
                    <h2>{member.firstName + " " + member.lastName}</h2>
                    <h3>{member.title}</h3>
                  </div>
                </div>
                <p>{member.description}</p>
              </AnimationOnScroll>
            );
          })}
        </div>
        
        <h1 className="team-board-members-title">Project Managers</h1>
        <div className="team-board-members-directors">
          {projectManagers.map((member, index) => {
            return (
              <AnimationOnScroll
                animateIn="animate__fadeInUp"
                className="team-member-director"
                animateOnce={true}
                key={member.firstName}>
                <div className="team-member-headshot">
                  <img
                    src={
                      "/headshots-2026/" +
                      member.lastName +
                      ", " +
                      member.firstName +
                      ".jpg"
                    }
                    alt={member.firstName}
                    style={{
                      transform: `translate(${member.headshotX || "0%"}, ${
                        member.headshotY || "0%"
                      }) scale(${member.headshotScale || 1})`,
                    }}
                  />
                </div>
                <div className="team-member-exec-info">
                  <div className="team-member-exec-info-left">
                    <h2>{member.firstName + " " + member.lastName}</h2>
                    <h3>{member.title}</h3>
                  </div>
                </div>
                <p>{member.description}</p>
              </AnimationOnScroll>
            );
          })}
        </div>
      </div>
    </div>
  );
};

export default TeamBoardMembers;
